(() => {
  if (window.hadayaMobileHome) return;
  window.hadayaMobileHome = true;
  const mobile = matchMedia('(max-width:767px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const book = document.querySelector('.hdy-book-with-story');
  const products = document.querySelector('[id$="__hadaya_favorites"]');
  const page = book?.querySelector('.hdy-quote-page');
  if (!book || !products || !page) return;
  const jerusalem=document.querySelector('.hdy-story');
  const newProducts=document.querySelector('[id$="__hadaya_new"]');
  if(jerusalem && newProducts) newProducts.before(jerusalem);
  const marker = document.createComment('Hadaya favorite products original position');
  products.before(marker);
  const bookSection=book.closest('.shopify-section');
  const intro=book.querySelector('.hdy-book-intro');
  const games=book.querySelector('.hdy-play-area');
  const storyPreview=book.querySelector('.hdy-story-preview');
  const leftStack=document.createElement('div');leftStack.className='hdy-book-left-stack';
  const rightStack=document.createElement('div');rightStack.className='hdy-book-right-stack';
  const seminary=document.querySelector('.hdy-seminary-home-entry');
  const studio=document.querySelector('.hdy-studio-invite');
  const seminaryMarker=document.createComment('Hadaya seminary link original position');
  if(seminary) seminary.before(seminaryMarker);
  function order() {
    if (mobile.matches) {
      products.classList.add('hdy-mobile-products');
      bookSection.before(products);
      [intro,page,games,storyPreview].forEach(element=>book.append(element));
      leftStack.remove();rightStack.remove();
      if(seminary) seminaryMarker.after(seminary);
    } else {
      marker.after(products);
      products.classList.remove('hdy-mobile-products');
      book.append(leftStack,rightStack);
      leftStack.append(intro,games);
      rightStack.append(page,storyPreview);
      if(seminary && studio) studio.after(seminary);
    }
  }
  order();
  mobile.addEventListener('change',order);
  const preview=book.querySelector('.hdy-story-preview');
  const frames=[...preview.querySelectorAll('.hdy-story-frames img')];
  const pause=preview.querySelector('.hdy-preview-pause');
  let timer=0,index=0,visible=false,paused=false;
  function show(next) {
    index=next;
    frames.forEach((frame,i)=>frame.classList.toggle('is-current',i===index));
  }
  function sync() {
    clearInterval(timer);timer=0;
    pause.hidden=reduced.matches;
    if(reduced.matches) show(0);
    if(!reduced.matches&&visible&&!document.hidden&&!paused&&!preview.matches(':focus-within')) {
      timer=setInterval(()=>show((index+1)%frames.length),5000);
    }
    pause.setAttribute('aria-pressed',String(paused));
    pause.textContent=paused?pause.dataset.resume:pause.dataset.pause;
    preview.dataset.rotating=String(!!timer);
  }
  pause.addEventListener('click',()=>{paused=!paused;sync();});
  preview.addEventListener('focusin',()=>{clearInterval(timer);timer=0;preview.dataset.rotating='false';});
  preview.addEventListener('focusout',()=>setTimeout(()=>{if(!preview.contains(document.activeElement))sync();},0));
  if('IntersectionObserver' in window) {
    new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.1}).observe(preview);
  }
  mobile.addEventListener('change',sync);
  reduced.addEventListener('change',sync);
  document.addEventListener('visibilitychange',sync);
  addEventListener('pagehide',()=>clearInterval(timer));
  sync();
})();
